<app-modal-panel #modalPanel [headerTitle]="title" [buttonTitle]="buttonTitle" [allowSubmit]="topicForm.form.valid" (submit)="onSave()">
    <div class="content">
      <div class="modal-body pt-0 pb-0">
        <div class="modal-content border-0">
          <form #topicForm="ngForm" novalidate (ngSubmit)="onSave()">
            <div class="row">
              <div class="col-sm-12 mb-1">
                <span class="title">Topic Name*</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <input inputFocus name="name" class="form-control border-0" type="text"
                  [(ngModel)]="topic.displayName" [attr.placeholder]="'Topic Name'" required>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mb-1">
                <span class="title">Topic Description*</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-textarea-counter inputFocus name="message" class="form-control p-0 round-0" required
                 [(ngModel)]="topic.description" [maxLength]="300" [placeholder]="'Topic Description'"></app-textarea-counter>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-3 mb-1">
                <span class="title">Publication Date*</span>
              </div>
            </div>
            <div class="row">
              <div class=	"col-sm-7">
                <app-date-picker name="publicationDate" [(ngModel)]="topic.createdTime" [allowNow]="true" required></app-date-picker>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </app-modal-panel>
